import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BackendTimeInterface } from '@core/interfaces/backend-time.interface';
import { of } from 'rxjs';

@Injectable()
export class BackendTimeEndpoint {
  private readonly urlIdentification = `${environment.apiExperience}/customer-identification`;

  constructor(private httpClient: HttpClient) {}

  getBackendTime() {
    return of ({
      isAvailable: true,
      allowedSchedule: true
    })
   /* const url = `${this.urlIdentification}/backend-time`;
    return this.httpClient.get<BackendTimeInterface>(url, {});*/
  }
}
